<template>
  <div class="login-account">
    <div class="login-sys-title">
      <div class="admin-title">拼满运后台管理系统</div>
      <div class="admin-subtitle">智运千里，准时如约</div>
      <div class="admin-welcome">HELLO!</div>
      <div class="admin-welcome">欢迎您登录系统</div>
    </div>
    <el-form class="login-form" ref="LoginForm" :model="loginForm" :rules="loginFormRules">
      <el-form-item prop="phone">
        <el-input v-model.number="loginForm.phone" placeholder="请输入登录账号" maxlength="11" id="username">
          <!--          <i class="el-icon-mobile-phone" slot="prefix"></i>-->
          <div class="box" slot="prefix">
            <el-image :src="accountImg" class="account-img"></el-image>
          </div>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input :type="inputType" v-model.trim="loginForm.password" placeholder="请输入平台登录密码" id="password">
          <!--          <i class="el-icon-mobile" slot="prefix"></i>-->
          <div class="box" slot="prefix">
            <el-image :src="passwordImg" class="account-img"></el-image>
          </div>
          <el-image
            :src="showPassword ? showPasswordImage : hidePasswordImage"
            slot="suffix"
            class="pass-image"
            @click="changeInputType"></el-image>
        </el-input>
      </el-form-item>
      <el-form-item prop="captcha" class="code-box" v-if="isNeedCode">
        <el-input v-model.trim="loginForm.captcha" placeholder="请输入验证码" id="code" maxLength="4">
          <div class="box" slot="prefix">
            <el-image :src="codeImg" class="account-img"></el-image>
          </div>
          <el-image
            v-loading="loadingCode"
            :src="codeImage"
            slot="suffix"
            class="code-image"
            @click="getLoginId"></el-image>
        </el-input>
      </el-form-item>
      <el-button @click="login" :disabled="loading" type="primary" class="btn_login">
        <el-image :src="require('@/assets/imgs/login.png')" v-if="!loading" class="login-img"></el-image>
        <i class="el-icon-loading" v-else></i>
        {{ loading ? "登录中..." : "登录" }}
      </el-button>
    </el-form>
  </div>
</template>

<script>
import { getCode, getRandom, getUserInfo, haveCode } from "@/views/login/api";
import CustomDateRange from "@/components/CustomDateRange.vue";
import { getAllConfig, getAreaTree } from "@/views/commonApi";
import { menus, permissions } from "./menus2";
import watermark from 'watermark-dom'
export default {
  components: { CustomDateRange },
  data() {
    return {
      accountImg: require("@/assets/imgs/admin.png"),
      passwordImg: require("@/assets/imgs/pass.png"),
      codeImg: require("@/assets/images/login/code.png"),
      loadingCode: false,
      isNeedCode: false,
      inputType: "password",
      showPassword: false,
      codeImage: "",

      showPasswordImage: require("@/assets/img/show-password.png"),
      hidePasswordImage: require("@/assets/img/hide-password.png"),
      imageUrl: require("@/assets/img/logo.png"),
      loading: false,
      loginForm: {
        // phone: "18333333333",
        // password: "Cs123456.",
        phone: "",
        password: "",
        loginId: "",
        captcha: "",
      },
      loginFormRules: {
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        enabled: [
          { required: true, message: "请阅读并同意协议", trigger: "change" },
        ],
      },
      menus,
      permissions,
    };
  },
  created() {
    watermark.load({
      watermark_txt: "",
      watermark_color: 'rgba(255,255,255,0)' //水印字体颜色
    });
    this.needCode();
  },
  mounted() {
    // window.addEventListener("keyup", this.onEnterKey);
  },
  // beforeDestroy() {
  //   window.removeEventListener("keyup", this.onEnterKey);
  // },
  methods: {
    onEnterKey(e) {
      if (e.keyCode === 13) {
        this.login();
      }
    },
    // 判断是否需要验证码登录
    needCode() {
      haveCode().then((res) => {
        if (res.code === 200) {
          this.isNeedCode = res.data;
          if (this.isNeedCode) {
            this.getLoginId();
          }
        }
      });
    },
    changeInputType() {
      this.showPassword = !this.showPassword;
      if (this.showPassword) {
        this.inputType = "text";
      } else {
        this.inputType = "password";
      }
    },
    changeCode() {
      this.loadingCode = true;
      getCode(this.loginForm.loginId)
        .then((res) => {
          this.loginForm.captcha = "";
          this.loadingCode = false;
          if (res.code === 200) {
            this.codeImage = "data:image/png;base64," + res.data.captcha;
          }
        })
        .catch((err) => {
          this.loadingCode = false;
          this.$message.error("获取验证码失败");
        });
    },

    getLoginId() {
      this.loadingCode = true;
      getRandom()
        .then((res) => {
          if (res.code === 200) {
            this.loginForm.loginId = res.data;
            this.changeCode();
          }
        })
        .catch((err) => {
          this.loadingCode = false;
        });
    },
    getAllConfigData() {
      getAllConfig().then((res) => {
        if (res.code === 200) {
          localStorage.setItem("config", JSON.stringify(res.data));
        }
      });
    },
    getTreeData() {
      getAreaTree().then((res) => {
        if (res.code === 200) {
          localStorage.setItem("area", JSON.stringify(res.data));
        }
      });
    },
    getUserData() {
      getUserInfo()
        .then((res) => {
          if (res.code === 200) {
            localStorage.setItem("u", JSON.stringify(res.data));
            localStorage.setItem("account", res.data.account);
            localStorage.setItem("companyType", res.data.companyType);
            localStorage.setItem("companyId", res.data.companyId);
            localStorage.setItem("companyName", res.data.companyName);
            localStorage.setItem("deptId", res.data.deptId);
            localStorage.setItem("deptName", res.data.deptName);
            localStorage.setItem("phone", res.data.phone);
            localStorage.setItem("roleId", res.data.roleId);
            localStorage.setItem("roleName", res.data.roleName);
            localStorage.setItem("userId", res.data.userId);
            localStorage.setItem("username", res.data.username);
            // // console.log(JSON.stringify(res.data.menus))
            localStorage.setItem("menus", JSON.stringify(res.data.menus));
            localStorage.setItem(
              "permissions",
              JSON.stringify(res.data.permissions)
            );
          }

          if (res.data.menus && res.data.menus.length > 0) {
            if (
              res.data.menus[0].children &&
              res.data.menus[0].children.length > 0
            ) {
              this.$router.replace({
                path: res.data.menus[0].children[0].menuLink,
              });
            } else {
              this.$router.replace({
                path: res.data.menus[0].menuLink,
              });
            }
          } else {
            this.$router.replace({
              path: "/",
            });
          }
        })
        .catch((err) => {});
    },
    login() {
      this.$refs["LoginForm"].validate(async (validate) => {
        if (!validate) return;
        this.loading = true;
        this.$store
          .dispatch("login", this.loginForm)
          .then((res) => {
            this.getAllConfigData();
            localStorage.setItem("token", res.accessToken);
            localStorage.setItem("refreshToken", res.refreshToken);
            localStorage.setItem("tokenType", res.tokenType);

            this.getUserData();
            this.getTreeData();

          })
          .catch((_) => {
            this.changeCode();
            this.loading = false;
          });
      });
    },
  },
};
</script>
<style lang="scss">
.login-account {
  .el-input__suffix-inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
  .el-input__inner {
    border: none;
    //border: 0.01rem solid #deddde;
  }
  .el-input__inner {
    height: 0.62rem;
    line-height: 0.62rem;
    border-radius: 0.1rem;
    padding-left: 0.52rem;
    padding-right: 0.46rem;
    background: #f5f5f7;
  }
  //.code-box {
  //  .el-input__inner {
  //    padding-left: 0.16rem;
  //  }
  //}
  .el-input__suffix {
    right: 0.16rem;
  }
  .el-input__prefix {
    display: flex;
    flex-direction: column;
    justify-content: center;
    left: 0.16rem;
    i {
      font-size: 0.2rem;
      color: #383f55;
    }
  }
  .el-input__icon,
  .el-input__prefix,
  .el-input__suffix {
    height: 100%;
  }
  .el-form-item {
    margin-bottom: 0.32rem;
  }

  .el-input__inner:focus {
    border: 0.03rem solid #1269ff;
    background-color: #ffffff;
  }
}
</style>
<style scoped lang="scss">
.login-account {
  width: 4.5rem;
  height: 5rem;
  box-sizing: border-box;
  .box {
    height: 0.48rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .account-img {
      width: 0.24rem;
      height: 0.24rem;
      position: relative;
    }
  }

  .login-sys-title {
    padding-bottom: 0.3rem;

    .admin-title {
      font-size: 0.26rem;
      color: #000000;
    }
    .admin-subtitle {
      font-size: 0.16rem;
      color: #8c8c8c;
      padding-bottom: 0.5rem;
      padding-top: 0.06rem;
    }
    .admin-welcome {
      font-size: 0.2rem;
      color: #000000;
      padding-bottom: 0.1rem;
    }
  }
  .code-image {
    width: 1.2rem;
    height: 0.52rem;
    //border: 0.01rem solid #eeeeee;
    border: none;
    cursor: pointer;
    position: relative;
    right: -0.1rem;
  }
  .pass-image {
    width: 0.24rem;
    height: 0.24rem;
    cursor: pointer;
  }
  .forget-pass {
    font-weight: 400;
    font-size: 0.14rem;
    color: #1269ff;
    padding-bottom: 0.1rem;
    text-align: right;
    position: relative;
    top: -0.1rem;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .btn_login {
    width: 100%;
    height: 0.52rem;
    border-radius: 0.04rem;
    font-size: 0.16rem;
    margin-top: 0.33rem;
  }
  .create-account {
    font-weight: 400;
    font-size: 0.14rem;
    color: #767c8c;
    margin-top: 0.16rem;
    text-align: center;
    span {
      color: #1269ff;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .login-img {
    width: 0.2rem;
    height: 0.2rem;
    margin-right: 0.06rem;
  }
  ::v-deep .el-button span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
